<div [editableInStoryblok]="_editable">
	<vp-usp-bar
		[isElevatedIcon]="false"
		[isStacked]="true"
		[rating]="hotelStore.rating()"
		[usps]="usps"
		iconVariant="accent"
	/>
</div>
